export const environment = {
  production: true,
  buildId: '2811677921219261',
  configFile: 'config.json',
};
